// import React, { useState } from "react";
// import "./NewPatientRegistration.css";

// // Premium Clinical Theme
// const theme = {
//   primaryDark: "#0f172a", primaryBlue: "#1e40af", accentCyan: "#0ea5e9",
//   bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
//   textMuted: "#64748b", borderLight: "#e2e8f0", successSoft: "#dcfce7",
//   successDark: "#15803d", dangerSoft: "#fee2e2", dangerDark: "#b91c1c",
//   warningSoft: "#fef9c3", warningDark: "#a16207",
//   gradientBg: "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)"
// };

// const MedicineDashboard = () => {
//   const [searchText, setSearchText] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
  
//   const [activeTab, setActiveTab] = useState("INDENTS");
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleSearch = async (value) => {
//     setSearchText(value);
//     if (value.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-by-id?q=${value}&employee_id=${user.id}`);
//       setSearchResults(await res.json() || []);
//       setShowDropdown(true);
//     } catch (err) { console.error("Search error:", err); }
//   };

//   const fetchMedicineDashboard = async (medicineId) => {
//     setShowDropdown(false);
//     setLoading(true);
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-dashboard/${medicineId}?employee_id=${user.id}`);
//       const data = await res.json();
      
//       if (data.success) {
//         setDashboardData(data);
//         setSearchText(`${data.profile.medicine_name} | ${data.profile.medicine_id}`);
//       } else alert(data.message || "Failed to load medicine data.");
//     } catch (err) { console.error("Dashboard fetch error:", err); }
//     setLoading(false);
//   };

//   const formatDate = (dateStr, includeTime = false) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     const options = { day: '2-digit', month: 'short', year: 'numeric' };
//     if (includeTime) { options.hour = '2-digit'; options.minute = '2-digit'; }
//     return date.toLocaleDateString('en-IN', options);
//   };

//   const tabs = [
//     { id: "INDENTS", label: "📝 Indents" },
//     { id: "POS", label: "🛒 Purchase Orders" },
//     { id: "MRN", label: "📦 Goods Received" },
//     { id: "ISSUES", label: "🚚 Transfers & Issues" },
//     { id: "CONSUMPTION", label: "💊 Consumptions" },
//     { id: "BILLING", label: "🧾 Patient Billing" }
//   ];

//   return (
//     <div className="registration-container fade-in" style={{ 
//       backgroundColor: theme.bgLight, minHeight: '100vh', padding: '20px 2%', 
//       boxSizing: 'border-box', fontFamily: "'Inter', 'Segoe UI', sans-serif", 
//       display: 'flex', flexDirection: 'column', overflowX: 'hidden' // 🔥 Allow vertical page scrolling
//     }}>
      
//       {/* 🔥 RESPONSIVE CSS INJECTED */}
//       <style>{`
//         .hospital-card { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); border: 1px solid ${theme.borderLight}; }
//         .hospital-card:hover { transform: translateY(-3px); box-shadow: 0 12px 25px -5px rgba(0,0,0,0.05); border-color: #cbd5e1; }
        
//         /* Mobile Scrollbar Magic */
//         .clean-scrollbar { -webkit-overflow-scrolling: touch; }
//         .clean-scrollbar::-webkit-scrollbar { height: 4px; width: 4px; }
//         .clean-scrollbar::-webkit-scrollbar-track { background: transparent; }
//         .clean-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        
//         .nav-tab { transition: all 0.2s ease-in-out; flex-shrink: 0; }
//         .nav-tab:hover:not(.active-tab) { background-color: #f1f5f9; color: ${theme.primaryBlue}; }

//         /* Mobile Responsiveness */
//         @media (max-width: 768px) {
//           .mobile-stack { flex-direction: column !important; align-items: flex-start !important; }
//           .mobile-grid-1 { grid-template-columns: 1fr !important; }
//           .hide-mobile { display: none !important; }
//           .header-banner { padding: 15px !important; }
//           .header-title { font-size: 20px !important; }
//           .search-wrapper { width: 100% !important; }
//         }
//       `}</style>

//       <div style={{ maxWidth: '1400px', margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', gap: '25px' }}>
        
//         {/* TOP SEARCH BAR */}
//         <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
//           <div className="search-wrapper" style={{ position: 'relative', width: '400px', zIndex: 100 }}>
//             <div style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: theme.textMuted }}>🔍</div>
//             <input type="text" value={searchText} placeholder="Search Medicine ID or Name..." onChange={(e) => handleSearch(e.target.value)}
//               style={{ width: '100%', padding: '14px 16px 14px 40px', borderRadius: '30px', border: `1px solid ${theme.borderLight}`, boxShadow: '0 4px 10px rgba(0,0,0,0.03)', fontSize: '14px', outline: 'none', transition: 'all 0.2s', backgroundColor: '#fff', boxSizing: 'border-box' }} 
//               onFocus={(e) => { e.target.style.boxShadow = `0 0 0 3px ${theme.accentCyan}33`; e.target.style.borderColor = theme.accentCyan; }}
//               onBlur={(e) => { e.target.style.boxShadow = '0 4px 10px rgba(0,0,0,0.03)'; e.target.style.borderColor = theme.borderLight; }}
//             />
//             {showDropdown && searchResults.length > 0 && (
//               <div style={{ position: 'absolute', top: '115%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '12px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', maxHeight: '300px', overflowY: 'auto', border: `1px solid ${theme.borderLight}` }} className="clean-scrollbar">
//                 {searchResults.map(m => (
//                   <div key={m.medicine_id} onClick={() => fetchMedicineDashboard(m.medicine_id)} style={{ padding: '12px 20px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <span style={{ fontWeight: '600', color: theme.textMain, fontSize: '14px' }}>{m.medicine_name}</span>
//                     <span style={{ fontSize: '12px', color: theme.primaryBlue, backgroundColor: '#eff6ff', padding: '4px 8px', borderRadius: '6px', fontWeight: '500' }}>{m.medicine_id}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', color: theme.accentCyan, fontWeight: '600', fontSize: '16px' }}>Loading Medicine Data...</div>}

//         {dashboardData && !loading && (
//           <>
//             {/* PREMIUM PROFILE HEADER */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              
//               {/* Gradient Banner */}
//               <div className="header-banner mobile-stack" style={{ background: theme.gradientBg, borderRadius: '16px', padding: '30px', color: '#fff', boxShadow: '0 10px 25px -5px rgba(14, 165, 233, 0.3)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
//                     <h1 className="header-title" style={{ margin: 0, fontSize: '28px', fontWeight: '800', letterSpacing: '-0.5px' }}>{dashboardData.profile.medicine_name}</h1>
//                     <span style={{ backgroundColor: dashboardData.profile.status === 'Active' ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)', color: dashboardData.profile.status === 'Active' ? '#86efac' : '#fca5a5', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', border: `1px solid ${dashboardData.profile.status === 'Active' ? '#4ade80' : '#f87171'}` }}>
//                       {dashboardData.profile.status}
//                     </span>
//                   </div>
//                   <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
//                     <span><strong style={{ opacity: 0.7 }}>ID:</strong> {dashboardData.profile.medicine_id}</span>
//                     <span className="hide-mobile" style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.4)' }}></span>
//                     <span><strong style={{ opacity: 0.7 }}>Category:</strong> {dashboardData.profile.category} ({dashboardData.profile.drug_type})</span>
//                     <span className="hide-mobile" style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.4)' }}></span>
//                     <span><strong style={{ opacity: 0.7 }}>Comp:</strong> {dashboardData.profile.composition}</span>
//                   </div>
//                 </div>
//                 <div style={{ textAlign: 'right' }} className="hide-mobile">
//                   <div style={{ fontSize: '12px', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Manufacturer</div>
//                   <div style={{ fontSize: '15px', fontWeight: '600' }}>{dashboardData.profile.manufacturer}</div>
//                 </div>
//               </div>

//               {/* Floating Stat Grid (Responsive) */}
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '15px', marginTop: '-5px' }}>
//                 <StatCard icon="💰" title="Pricing (Pur / MRP / Sell)" value={`₹${dashboardData.profile.purchase_price} / ₹${dashboardData.profile.mrp} / ₹${dashboardData.profile.selling_price}`} />
//                 <StatCard icon="📉" title="Stock Levels (Min/Max/Reorder)" value={`${dashboardData.profile.min_level} / ${dashboardData.profile.max_level} / ${dashboardData.profile.reorder_level}`} highlight={theme.warningDark} />
//                 <StatCard icon="🧾" title="Taxes & Tracking" value={`GST: ${dashboardData.profile.gst_percentage}% | Code: ${dashboardData.profile.barcode || 'N/A'}`} />
//                 <StatCard icon="🌡️" title="Logistics" value={`Storage: ${dashboardData.profile.storage_condition}`}  />
//               </div>
//             </div>

//             {/* SLEEK TAB NAVIGATION (Scrollable horizontally on mobile) */}
//             <div className="clean-scrollbar" style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '10px', marginTop: '10px', borderBottom: `2px solid ${theme.borderLight}` }}>
//               {tabs.map(tab => (
//                 <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`nav-tab ${activeTab === tab.id ? 'active-tab' : ''}`}
//                   style={{ 
//                     padding: '12px 24px', cursor: 'pointer', fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap',
//                     backgroundColor: activeTab === tab.id ? theme.primaryBlue : 'transparent', 
//                     color: activeTab === tab.id ? '#ffffff' : theme.textMuted,
//                     border: 'none', borderRadius: '30px', outline: 'none',
//                     boxShadow: activeTab === tab.id ? '0 4px 15px rgba(30, 64, 175, 0.25)' : 'none' 
//                   }}>
//                   {tab.label}
//                 </button>
//               ))}
//             </div>

//             {/* MAIN CONTENT AREA (No fixed height - naturally expands page) */}
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '40px' }}>
              
//               {/* ================= INDENTS ================= */}
//               {activeTab === "INDENTS" && (
//                 <>
//                   {dashboardData.indents.length === 0 ? <EmptyState msg="No indent history found." /> : dashboardData.indents.map(ind => (
//                     <div key={ind.id} className="hospital-card" style={{ backgroundColor: theme.cardBg, borderRadius: '12px', overflow: 'hidden' }}>
//                       <div className="mobile-stack" style={{ padding: '15px 20px', borderBottom: `1px solid ${theme.borderLight}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc', gap: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                           <span style={{ fontSize: '18px' }}>📝</span>
//                           <div>
//                             <strong style={{ color: theme.primaryDark, fontSize: '15px' }}>{ind.indent_number}</strong>
//                             <span style={{ fontSize: '12px', color: theme.textMuted, marginLeft: '8px' }}>{formatDate(ind.indent_date)}</span>
//                           </div>
//                         </div>
//                         <Badge text={ind.indent_status} type={ind.indent_status.includes('Ordered') ? 'success' : 'warning'} />
//                       </div>
//                       <div className="mobile-grid-1" style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '20px' }}>
//                         <DetailRow label="Location" value={ind.location_name} />
//                         <DetailRow label="Target Supplier" value={ind.supplier_name} />
//                         <DetailRow label="Indent Qty" value={`${ind.indent_qty} ${ind.unit}`} color={theme.accentCyan} size="large" />
//                         <DetailRow label="Ordered Qty" value={`${ind.ordered_qty} ${ind.unit}`} color={theme.successDark} size="large" />
//                         <DetailRow label="Rates & Taxes" value={`Rate: ₹${ind.purchase_rate} | MRP: ₹${ind.mrp} | GST: ${ind.gst_percent}%`} />
//                         <DetailRow label="Est. Value" value={`₹${ind.estimated_value}`} color={theme.dangerDark} />
//                         <DetailRow label="Created By" value={ind.created_by_name} />
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               )}

//               {/* ================= PURCHASE ORDERS ================= */}
//               {activeTab === "POS" && (
//                 <>
//                   {dashboardData.pos.length === 0 ? <EmptyState msg="No Purchase Order history found." /> : dashboardData.pos.map(po => (
//                     <div key={po.id} className="hospital-card" style={{ backgroundColor: theme.cardBg, borderRadius: '12px', overflow: 'hidden' }}>
//                       <div className="mobile-stack" style={{ padding: '15px 20px', borderBottom: `1px solid ${theme.borderLight}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc', gap: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                           <span style={{ fontSize: '18px' }}>🛒</span>
//                           <div>
//                             <strong style={{ color: theme.primaryDark, fontSize: '15px' }}>{po.po_number}</strong>
//                             <span style={{ fontSize: '12px', color: theme.textMuted, marginLeft: '8px' }}>{formatDate(po.po_date)}</span>
//                           </div>
//                         </div>
//                         <Badge text={po.po_status} type={po.po_status === 'Approved' || po.po_status === 'Completed' ? 'success' : 'primary'} />
//                       </div>
//                       <div className="mobile-grid-1" style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '20px' }}>
//                         <DetailRow label="Supplier" value={po.supplier_name} />
//                         <DetailRow label="Order Qty" value={`${po.quantity} ${po.unit} (+${po.free_quantity} Free)`} color={theme.primaryBlue} size="large" />
//                         <DetailRow label="Pur Rate & Amt" value={`₹${po.purchase_rate} (Tot: ₹${po.purchase_amount})`} />
//                         <DetailRow label="MRP" value={`₹${po.mrp}`} />
//                         <DetailRow label="Discount" value={`${po.discount_percent}% (₹${po.discount_amount})`} color={theme.successDark} />
//                         <DetailRow label="Line Total" value={`₹${po.line_total}`} color={theme.dangerDark} size="large" />
//                         <DetailRow label="Expiry Date" value={formatDate(po.expiry_date)} />
//                         <DetailRow label="Created By" value={po.created_by_name} />
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               )}

//               {/* ================= MRN (GOODS RECEIVED) ================= */}
//               {activeTab === "MRN" && (
//                 <>
//                   {dashboardData.mrns.length === 0 ? <EmptyState msg="No Goods Received (MRN) history found." /> : dashboardData.mrns.map(mrn => (
//                     <div key={mrn.id} className="hospital-card" style={{ backgroundColor: theme.cardBg, borderRadius: '12px', overflow: 'hidden' }}>
//                       <div className="mobile-stack" style={{ padding: '15px 20px', borderBottom: `1px solid ${theme.borderLight}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc', gap: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                           <span style={{ fontSize: '18px' }}>📦</span>
//                           <div>
//                             <strong style={{ color: theme.primaryDark, fontSize: '15px' }}>{mrn.mrn_number}</strong>
//                             <span style={{ fontSize: '12px', color: theme.textMuted, marginLeft: '8px' }}>{formatDate(mrn.mrn_date)}</span>
//                           </div>
//                         </div>
//                         <span style={{ fontSize: '12px', fontWeight: '600', color: theme.primaryBlue, backgroundColor: '#e0e7ff', padding: '4px 10px', borderRadius: '6px' }}>PO: {mrn.po_number}</span>
//                       </div>
//                       <div className="mobile-grid-1" style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '20px' }}>
//                         <DetailRow label="Supplier" value={mrn.supplier_name} />
//                         <DetailRow label="Ordered Qty" value={`${mrn.ordered_qty} ${mrn.unit}`} />
//                         <DetailRow label="Received Qty" value={`${mrn.received_qty} ${mrn.unit} (+${mrn.free_quantity} Free)`} color={theme.successDark} size="large" />
//                         <DetailRow label="Batch No" value={mrn.batch_no || 'N/A'} color={theme.primaryDark} />
//                         <DetailRow label="Expiry Date" value={formatDate(mrn.expiry_date)} color={theme.dangerDark} />
//                         <DetailRow label="Bin Location" value={mrn.bin_location || 'N/A'} />
//                         <DetailRow label="Received By" value={mrn.created_by_name} />
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               )}

//               {/* ================= ISSUES / TRANSFERS ================= */}
//               {activeTab === "ISSUES" && (
//                 <>
//                   {dashboardData.issues.length === 0 ? <EmptyState msg="No Stock Issues/Transfers found." /> : dashboardData.issues.map(iss => (
//                     <div key={iss.id} className="hospital-card" style={{ backgroundColor: theme.cardBg, borderRadius: '12px', overflow: 'hidden' }}>
//                       <div className="mobile-stack" style={{ padding: '15px 20px', borderBottom: `1px solid ${theme.borderLight}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc', gap: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                           <span style={{ fontSize: '18px' }}>🚚</span>
//                           <div>
//                             <strong style={{ color: theme.primaryDark, fontSize: '15px' }}>{iss.issue_id}</strong>
//                             <span style={{ fontSize: '12px', color: theme.textMuted, marginLeft: '8px' }}>{formatDate(iss.issue_dt)}</span>
//                           </div>
//                         </div>
//                         <Badge text={`To: ${iss.issued_to}`} type="cyan" />
//                       </div>
//                       <div className="mobile-grid-1" style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
//                         <DetailRow label="Issued Qty" value={`${iss.issued_qty} ${iss.unit}`} color={theme.accentCyan} size="large" />
//                         <DetailRow label="Batch No" value={iss.batch_no} />
//                         <DetailRow label="Expiry Date" value={formatDate(iss.expiry_date)} color={theme.dangerDark} />
//                         <DetailRow label="Issued By" value={iss.created_by_name} />
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               )}

//               {/* ================= CONSUMPTIONS ================= */}
//               {activeTab === "CONSUMPTION" && (
//                 <>
//                   {dashboardData.consumptions.length === 0 ? <EmptyState msg="No internal consumption records found." /> : dashboardData.consumptions.map(con => (
//                     <div key={con.id} className="hospital-card" style={{ backgroundColor: theme.cardBg, borderRadius: '12px', overflow: 'hidden' }}>
//                       <div className="mobile-stack" style={{ padding: '15px 20px', borderBottom: `1px solid ${theme.borderLight}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc', gap: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                           <span style={{ fontSize: '18px' }}>💊</span>
//                           <div>
//                             <strong style={{ color: theme.primaryDark, fontSize: '15px' }}>{con.consumption_id}</strong>
//                             <span style={{ fontSize: '12px', color: theme.textMuted, marginLeft: '8px' }}>{formatDate(con.consumption_date)}</span>
//                           </div>
//                         </div>
//                         <Badge text={`Location: ${con.location}`} type="warning" />
//                       </div>
//                       <div className="mobile-grid-1" style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '20px' }}>
//                         <DetailRow label="Patient" value={`${con.patient_name} (${con.patient_id})`} color={theme.primaryBlue} />
//                         <DetailRow label="Consumed Qty" value={`${con.consumed_qty} ${con.unit}`} color={theme.dangerDark} size="large" />
//                         <DetailRow label="Batch No" value={con.batch_no} />
//                         <DetailRow label="Expiry Date" value={formatDate(con.expiry_date)} />
//                         <DetailRow label="Logged By" value={con.created_by_name} />
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               )}

//               {/* ================= BILLING ================= */}
//               {activeTab === "BILLING" && (
//                 <>
//                   {dashboardData.billing.length === 0 ? <EmptyState msg="No patient billing history found." /> : dashboardData.billing.map(bill => (
//                     <div key={bill.id} className="hospital-card" style={{ backgroundColor: theme.cardBg, borderRadius: '12px', overflow: 'hidden' }}>
//                       <div className="mobile-stack" style={{ padding: '15px 20px', borderBottom: `1px solid ${theme.borderLight}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8fafc', gap: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                           <span style={{ fontSize: '18px' }}>🧾</span>
//                           <div>
//                             <strong style={{ color: theme.primaryDark, fontSize: '15px' }}>{bill.bill_number}</strong>
//                             <span style={{ fontSize: '12px', color: theme.textMuted, marginLeft: '8px' }}>{formatDate(bill.bill_date)}</span>
//                           </div>
//                         </div>
//                         <Badge text={`Billed Qty: ${bill.qty} ${bill.unit}`} type="success" />
//                       </div>
//                       <div className="mobile-grid-1" style={{ padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '20px' }}>
//                         <DetailRow label="Patient" value={`${bill.patient_name} (${bill.patient_id})`} color={theme.primaryBlue} />
//                         <DetailRow label="Gross Value" value={`₹${bill.value_amount}`} />
//                         <DetailRow label="Billed MRP" value={`₹${bill.mrp} (Net: ₹${bill.net_amount})`} color={theme.successDark} size="large" />
//                         <DetailRow label="Discount" value={`${bill.discount_percent}% (₹${bill.discount_amount})`} color={theme.dangerDark} />
//                         <DetailRow label="Batch No" value={bill.batch_no} />
//                         <DetailRow label="Billed By" value={bill.created_by_name} />
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// // ================= REUSABLE LUXURY COMPONENTS =================

// const StatCard = ({ title, value, subText, icon, highlight }) => (
//   <div style={{ backgroundColor: theme.cardBg, padding: '18px 20px', borderRadius: '12px', border: `1px solid ${theme.borderLight}`, display: 'flex', gap: '15px', alignItems: 'center', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.02)' }}>
//     <div style={{ fontSize: '28px', backgroundColor: theme.bgLight, padding: '12px', borderRadius: '12px', color: theme.primaryBlue }}>{icon}</div>
//     <div style={{ display: 'flex', flexDirection: 'column' }}>
//       <span style={{ fontSize: '11px', color: theme.textMuted, textTransform: 'uppercase', fontWeight: '700', letterSpacing: '0.5px' }}>{title}</span>
//       <span style={{ fontSize: '16px', fontWeight: '800', color: highlight || theme.textMain, marginTop: '4px' }}>{value}</span>
//       {subText && <span style={{ fontSize: '12px', color: theme.textMuted, marginTop: '2px', fontWeight: '500' }}>{subText}</span>}
//     </div>
//   </div>
// );

// const DetailRow = ({ label, value, color, size }) => (
//   <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//     <span style={{ fontSize: '11px', color: theme.textMuted, fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</span>
//     <span style={{ fontSize: size === 'large' ? '17px' : '14px', fontWeight: size === 'large' ? '800' : '600', color: color || theme.textMain }}>{value || 'N/A'}</span>
//   </div>
// );

// const Badge = ({ text, type }) => {
//   const styles = {
//     cyan: { bg: '#e0f2fe', color: '#0369a1', border: '#bae6fd' }, 
//     primary: { bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' },
//     success: { bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0' }, 
//     warning: { bg: '#fefce8', color: '#a16207', border: '#fef08a' },
//     danger: { bg: '#fef2f2', color: '#b91c1c', border: '#fecaca' }
//   };
//   const activeStyle = styles[type] || { bg: '#f8fafc', color: theme.textMuted, border: theme.borderLight };
  
//   return (
//     <span style={{ 
//       backgroundColor: activeStyle.bg, color: activeStyle.color, border: `1px solid ${activeStyle.border}`,
//       padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', letterSpacing: '0.3px', display: 'inline-block' 
//     }}>
//       {text}
//     </span>
//   );
// };

// const EmptyState = ({ msg }) => (
//   <div style={{ padding: '60px 20px', textAlign: 'center', backgroundColor: theme.cardBg, borderRadius: '12px', border: `1px dashed #cbd5e1`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
//     <div style={{ fontSize: '32px', opacity: 0.5 }}>📂</div>
//     <div style={{ color: theme.textMuted, fontSize: '15px', fontWeight: '600' }}>{msg}</div>
//   </div>
// );

// export default MedicineDashboard;

import React, { useState } from "react";
import "./NewPatientRegistration.css";

// Premium Clinical Theme
const theme = {
  primaryDark: "#0f172a", primaryBlue: "#1e40af", accentCyan: "#0ea5e9",
  bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
  textMuted: "#64748b", borderLight: "#e2e8f0", successSoft: "#dcfce7",
  successDark: "#15803d", dangerSoft: "#fee2e2", dangerDark: "#b91c1c",
  warningSoft: "#fef9c3", warningDark: "#a16207",
  gradientBg: "linear-gradient(135deg, #1e40af 0%, #0ea5e9 100%)"
};

const MedicineDashboard = () => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  
  const [activeTab, setActiveTab] = useState("INDENTS");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (value) => {
    setSearchText(value);
    if (value.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-by-id?q=${value}&employee_id=${user.id}`);
      setSearchResults(await res.json() || []);
      setShowDropdown(true);
    } catch (err) { console.error("Search error:", err); }
  };

  const fetchMedicineDashboard = async (medicineId) => {
    setShowDropdown(false);
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-dashboard/${medicineId}?employee_id=${user.id}`);
      const data = await res.json();
      
      if (data.success) {
        setDashboardData(data);
        setSearchText(`${data.profile.medicine_name} | ${data.profile.medicine_id}`);
      } else alert(data.message || "Failed to load medicine data.");
    } catch (err) { console.error("Dashboard fetch error:", err); }
    setLoading(false);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const tabs = [
    { id: "INDENTS", label: "📝 Indents" },
    { id: "POS", label: "🛒 Purchase Orders" },
    { id: "MRN", label: "📦 Goods Received" },
    { id: "ISSUES", label: "🚚 Transfers & Issues" },
    { id: "CONSUMPTION", label: "💊 Consumptions" },
    { id: "BILLING", label: "🧾 Patient Billing" }
  ];

  return (
    <div className="registration-container fade-in" style={{ 
      backgroundColor: theme.bgLight, minHeight: '100vh', padding: '20px 2%', 
      boxSizing: 'border-box', fontFamily: "'Inter', 'Segoe UI', sans-serif", 
      display: 'flex', flexDirection: 'column', overflowX: 'hidden' 
    }}>
      
      {/* 🔥 ENHANCED GRID & SEARCH CSS */}
      <style>{`
        /* Excel Grid Styling */
        .erp-grid { width: 100%; border-collapse: collapse; background: #fff; font-size: 12.5px; border-radius: 8px; overflow: hidden; }
        .erp-grid th { background: #f8fafc; color: ${theme.primaryDark}; padding: 12px 10px; text-align: left; font-weight: 700; border-bottom: 2px solid ${theme.borderLight}; position: sticky; top: 0; z-index: 10; white-space: nowrap; text-transform: uppercase; letter-spacing: 0.3px; }
        .erp-grid td { padding: 10px; border-bottom: 1px solid ${theme.borderLight}; color: ${theme.textMain}; white-space: nowrap; }
        .erp-grid tr:hover { background-color: #f1f5f9; }
        .grid-container { background: #fff; border-radius: 12px; border: 1px solid ${theme.borderLight}; overflow-x: auto; box-shadow: 0 4px 20px rgba(0,0,0,0.04); }

        /* Scrollbar Magic */
        .clean-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
        .clean-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .clean-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        
        .nav-tab { transition: all 0.2s ease-in-out; flex-shrink: 0; }
        .nav-tab:hover:not(.active-tab) { background-color: #f1f5f9; color: ${theme.primaryBlue}; }

        @media (max-width: 768px) {
          .mobile-stack { flex-direction: column !important; align-items: flex-start !important; }
          .hide-mobile { display: none !important; }
          .search-wrapper { width: 100% !important; }
        }
      `}</style>

      <div style={{ maxWidth: '1600px', margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', gap: '25px' }}>
        
        {/* LUXURIOUS TOP SEARCH BAR */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <div className="search-wrapper" style={{ position: 'relative', width: '450px', zIndex: 100 }}>
            <div style={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', color: theme.textMuted, fontSize: '18px' }}>🔍</div>
            <input type="text" value={searchText} placeholder="Search Medicine ID or Name..." onChange={(e) => handleSearch(e.target.value)}
              style={{ width: '100%', padding: '14px 16px 14px 40px', borderRadius: '30px', border: `1px solid ${theme.borderLight}`, boxShadow: '0 4px 10px rgba(0,0,0,0.03)', fontSize: '14px', outline: 'none', transition: 'all 0.2s', backgroundColor: '#fff', boxSizing: 'border-box' }} 
              onFocus={(e) => { e.target.style.boxShadow = `0 0 0 4px ${theme.accentCyan}22`; e.target.style.borderColor = theme.accentCyan; }}
            />
            {showDropdown && searchResults.length > 0 && (
              <div style={{ position: 'absolute', top: '115%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '15px', boxShadow: '0 20px 35px rgba(0,0,0,0.12)', maxHeight: '300px', overflowY: 'auto', border: `1px solid ${theme.borderLight}` }} className="clean-scrollbar">
                {searchResults.map(m => (
                  <div key={m.medicine_id} onClick={() => fetchMedicineDashboard(m.medicine_id)} style={{ padding: '15px 25px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: '700', color: theme.textMain, fontSize: '14px' }}>{m.medicine_name}</span>
                    <span style={{ fontSize: '11px', color: theme.primaryBlue, backgroundColor: '#eff6ff', padding: '5px 10px', borderRadius: '20px', fontWeight: '700' }}>{m.medicine_id}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', color: theme.accentCyan, fontWeight: '600' }}>Loading Clinical Data...</div>}

        {dashboardData && !loading && (
          <>
            {/* RICH TOP SECTION (KEPT ORIGINAL) */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div className="header-banner mobile-stack" style={{ background: theme.gradientBg, borderRadius: '20px', padding: '15px', color: '#fff', boxShadow: '0 15px 30px -10px rgba(30, 64, 175, 0.4)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
                    <h1 className="header-title" style={{ margin: 0, fontSize: '28px', fontWeight: '900', letterSpacing: '-0.8px' }}>{dashboardData.profile.medicine_name}</h1>
                    <span style={{ backgroundColor: 'rgba(255,255,255,0.2)', color: '#fff', padding: '6px 14px', borderRadius: '30px', fontSize: '13px', fontWeight: '800', border: '1px solid rgba(255,255,255,0.4)' }}>
                      {dashboardData.profile.status}
                    </span>
                  </div>
                  <div style={{ fontSize: '15px', color: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', fontWeight: '500' }}>
                    <span>ID: {dashboardData.profile.medicine_id}</span>
                    <span className="hide-mobile" style={{ opacity: 0.5 }}>|</span>
                    <span>Category: {dashboardData.profile.category}</span>
                    <span className="hide-mobile" style={{ opacity: 0.5 }}>|</span>
                    <span>Comp: {dashboardData.profile.composition}</span>
                  </div>
                </div>
                <div style={{ textAlign: 'right' }} className="hide-mobile">
                  <div style={{ fontSize: '11px', opacity: 0.7, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '4px' }}>Manufacturer</div>
                  <div style={{ fontSize: '17px', fontWeight: '700' }}>{dashboardData.profile.manufacturer}</div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '15px', marginTop: '-5px' }}>
                <StatCard icon="💰" title="Pricing (Pur / MRP / Sell)" value={`₹${dashboardData.profile.purchase_price} / ₹${dashboardData.profile.mrp} / ₹${dashboardData.profile.selling_price}`} />
                <StatCard icon="📉" title="Stock (Min/Max/Reorder)" value={`${dashboardData.profile.min_level} / ${dashboardData.profile.max_level} / ${dashboardData.profile.reorder_level}`} highlight={theme.warningDark} />
                <StatCard icon="🧾" title="Taxes & Tracking" value={`GST: ${dashboardData.profile.gst_percentage}% | Barcode: ${dashboardData.profile.barcode || 'N/A'}`} />
                <StatCard icon="🌡️" title="Logistics" value={`Storage: ${dashboardData.profile.storage_condition}`}  />
              </div>
            </div>

            {/* TAB NAVIGATION */}
            <div className="clean-scrollbar" style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '5px', marginTop: '10px' }}>
              {tabs.map(tab => (
                <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`nav-tab ${activeTab === tab.id ? 'active-tab' : ''}`}
                  style={{ 
                    padding: '12px 28px', cursor: 'pointer', fontWeight: '700', fontSize: '14px', whiteSpace: 'nowrap',
                    backgroundColor: activeTab === tab.id ? theme.primaryBlue : '#fff', 
                    color: activeTab === tab.id ? '#ffffff' : theme.textMuted,
                    border: `1px solid ${activeTab === tab.id ? theme.primaryBlue : theme.borderLight}`, borderRadius: '40px', outline: 'none',
                    boxShadow: activeTab === tab.id ? '0 8px 20px rgba(30, 64, 175, 0.2)' : '0 4px 6px rgba(0,0,0,0.02)' 
                  }}>
                  {tab.label}
                </button>
              ))}
            </div>

            {/* 🔥 HIGH-DENSITY ERP EXCEL GRIDS */}
            <div className="grid-container clean-scrollbar">
              
              {activeTab === "INDENTS" && (
                <table className="erp-grid">
                  <thead>
                    <tr>
                      <th>Indent No</th><th>Date</th><th>Location</th><th>Supplier</th><th>Indent Qty</th><th>Ordered</th><th>Rate</th><th>GST%</th><th>Est. Value</th><th>Status</th><th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.indents.length === 0 ? <tr><td colSpan="11" style={{textAlign:'center', padding: '40px'}}>No Indent Records Found</td></tr> : 
                      dashboardData.indents.map(row => (
                        <tr key={row.id}>
                          <td style={{fontWeight: '700', color: theme.primaryBlue}}>{row.indent_number}</td>
                          <td>{formatDate(row.indent_date)}</td>
                          <td>{row.location_name}</td>
                          <td>{row.supplier_name}</td>
                          <td style={{fontWeight: '800'}}>{row.indent_qty} {row.unit}</td>
                          <td style={{color: theme.successDark, fontWeight: '700'}}>{row.ordered_qty}</td>
                          <td>₹{row.purchase_rate}</td>
                          <td>{row.gst_percent}%</td>
                          <td style={{fontWeight: '700'}}>₹{row.estimated_value}</td>
                          <td><Badge text={row.indent_status} type={row.indent_status.includes('PO') ? 'success' : 'warning'} /></td>
                          <td>{row.created_by_name}</td>
                        </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {activeTab === "POS" && (
                <table className="erp-grid">
                  <thead>
                    <tr>
                      <th>PO No</th><th>Date</th><th>Supplier</th><th>Qty (Free)</th><th>Rate</th><th>MRP</th><th>Disc%</th><th>GST%</th><th>Net Total</th><th>Status</th><th>By</th><th>Approved By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.pos.length === 0 ? <tr><td colSpan="12" style={{textAlign:'center', padding: '40px'}}>No Purchase Orders Available</td></tr> : 
                      dashboardData.pos.map(row => (
                        <tr key={row.id}>
                          <td style={{fontWeight: '700', color: theme.primaryBlue}}>{row.po_number}</td>
                          <td>{formatDate(row.po_date)}</td>
                          <td>{row.supplier_name}</td>
                          <td style={{fontWeight: '700'}}>{row.quantity} (+{row.free_quantity})</td>
                          <td>₹{row.purchase_rate}</td>
                          <td>₹{row.mrp}</td>
                          <td style={{color: theme.dangerDark}}>{row.discount_percent}%</td>
                          <td>{row.gst_percent}%</td>
                          <td style={{fontWeight: '800', color: theme.primaryDark}}>₹{row.line_total}</td>
                          <td><Badge text={row.po_status} type={row.po_status === 'Approved' ? 'success' : 'primary'} /></td>
                          <td>{row.created_by_name}</td>
                          <td style={{fontWeight: '700', color: theme.successDark}}>{row.approved_by_name || '—'}</td>
                        </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {activeTab === "MRN" && (
                <table className="erp-grid">
                  <thead>
                    <tr>
                      <th>MRN No</th><th>Date</th><th>PO Link</th><th>Supplier</th><th>Recv Qty</th><th>Batch No</th><th>Mfg Dt</th><th>Exp Dt</th><th>Bin</th><th>Received By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.mrns.map(row => (
                      <tr key={row.id}>
                        <td style={{fontWeight: '700', color: theme.primaryBlue}}>{row.mrn_number}</td>
                        <td>{formatDate(row.mrn_date)}</td>
                        <td style={{fontSize: '11px', fontWeight: '600'}}>{row.po_number}</td>
                        <td>{row.supplier_name}</td>
                        <td style={{fontWeight: '700', color: theme.successDark}}>{row.received_qty} (+{row.free_quantity})</td>
                        <td><span style={{background: '#f1f5f9', padding: '3px 8px', borderRadius: '4px', fontWeight: '600'}}>{row.batch_no || '—'}</span></td>
                        <td>{formatDate(row.mfg_date)}</td>
                        <td style={{color: theme.dangerDark, fontWeight: '700'}}>{formatDate(row.expiry_date)}</td>
                        <td>{row.bin_location}</td>
                        <td>{row.created_by_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {activeTab === "ISSUES" && (
                <table className="erp-grid">
                  <thead>
                    <tr>
                      <th>Issue ID</th><th>Date</th><th>Issued To</th><th>Issued Qty</th><th>Batch No</th><th>Expiry</th><th>Issued By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.issues.map(row => (
                      <tr key={row.id}>
                        <td style={{fontWeight: '700'}}>{row.issue_id}</td>
                        <td>{formatDate(row.issue_dt)}</td>
                        <td style={{fontWeight: '600'}}>{row.issued_to}</td>
                        <td style={{fontWeight: '700', color: theme.accentCyan}}>{row.issued_qty} {row.unit}</td>
                        <td>{row.batch_no}</td>
                        <td>{formatDate(row.expiry_date)}</td>
                        <td>{row.created_by_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {activeTab === "CONSUMPTION" && (
                <table className="erp-grid">
                  <thead>
                    <tr>
                      <th>ID</th><th>Date</th><th>Location</th><th>Patient</th><th>Consumed Qty</th><th>Batch</th><th>Exp Dt</th><th>Logged By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.consumptions.map(row => (
                      <tr key={row.id}>
                        <td style={{fontWeight: '600'}}>{row.consumption_id}</td>
                        <td>{formatDate(row.consumption_date)}</td>
                        <td>{row.location}</td>
                        <td>{row.patient_name} <small style={{color: theme.textMuted}}>({row.patient_id})</small></td>
                        <td style={{fontWeight: '700', color: theme.dangerDark}}>{row.consumed_qty} {row.unit}</td>
                        <td>{row.batch_no}</td>
                        <td>{formatDate(row.expiry_date)}</td>
                        <td>{row.created_by_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {activeTab === "BILLING" && (
                <table className="erp-grid">
                  <thead>
                    <tr>
                      <th>Bill No</th><th>Date</th><th>Patient</th><th>Qty</th><th>Gross</th><th>Disc%</th><th>Net Amount</th><th>Batch</th><th>Billed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData.billing.map(row => (
                      <tr key={row.id}>
                        <td style={{fontWeight: '700'}}>{row.bill_number}</td>
                        <td>{formatDate(row.bill_date)}</td>
                        <td style={{fontWeight: '600'}}>{row.patient_name}</td>
                        <td>{row.qty} {row.unit}</td>
                        <td>₹{row.value_amount}</td>
                        <td style={{color: theme.dangerDark}}>{row.discount_percent}%</td>
                        <td style={{fontWeight: '800', color: theme.successDark}}>₹{row.net_amount}</td>
                        <td>{row.batch_no}</td>
                        <td>{row.created_by_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

            </div>
          </>
        )}
      </div>
    </div>
  );
};

// ================= REUSABLE COMPONENTS =================

const StatCard = ({ title, value, icon, highlight }) => (
  <div style={{ backgroundColor: theme.cardBg, padding: '20px', borderRadius: '15px', border: `1px solid ${theme.borderLight}`, display: 'flex', gap: '15px', alignItems: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.02)' }}>
    <div style={{ fontSize: '28px', backgroundColor: theme.bgLight, padding: '12px', borderRadius: '12px', color: theme.primaryBlue }}>{icon}</div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span style={{ fontSize: '11px', color: theme.textMuted, textTransform: 'uppercase', fontWeight: '800', letterSpacing: '0.8px' }}>{title}</span>
      <span style={{ fontSize: '15px', fontWeight: '800', color: highlight || theme.textMain, marginTop: '3px' }}>{value}</span>
    </div>
  </div>
);

const Badge = ({ text, type }) => {
  const styles = {
    success: { bg: '#dcfce7', color: '#15803d', border: '#bbf7d0' }, 
    warning: { bg: '#fefce8', color: '#a16207', border: '#fef08a' },
    primary: { bg: '#eff6ff', color: '#1e40af', border: '#bfdbfe' }
  };
  const s = styles[type] || { bg: '#f1f5f9', color: theme.textMuted, border: theme.borderLight };
  
  return (
    <span style={{ backgroundColor: s.bg, color: s.color, border: `1px solid ${s.border}`, padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '800', display: 'inline-block' }}>
      {text}
    </span>
  );
};

const EmptyState = ({ msg }) => (
  <div style={{ padding: '80px 20px', textAlign: 'center', color: theme.textMuted, fontSize: '15px', fontWeight: '600' }}>
    <div style={{ fontSize: '40px', marginBottom: '10px' }}>📂</div>
    {msg}
  </div>
);

export default MedicineDashboard;